<ng-container>
  <div class="modal-header">
    <h5 class="modal-title">Add new Signing Agent Designation</h5>
  </div>
  <div class="modal-body">
    <div class="modal-section">
      Designations can only be given to accounts that already hold the Signing Agent role. Please enter the email address below and select the corresponding Designation. When ready, click "Add Designations" to add them.
    </div>
    <div class="modal-section">
      <small class="text-muted">
        <strong>Designation Descriptions: </strong>
        <em>Team Signing Agent</em> and <em>Preferred Agent</em> are additional descriptors on a signing agent. An agent holds one of these or neither - never both. Setting a designation replaces any designation they already have.
      </small>
    </div>
    <form [formGroup]="addDesignationForm" class="clrsgn-form">
      <div formArrayName="designationAccounts">
        @for (designationAccountGroup of addDesignationsArray.controls; track designationAccountGroup; let i = $index) {
          <div [formGroupName]="i">
            @if (i > 0) {
              <hr class="split"/>
            }
            <div class="modal-section">
              New Designation {{ i + 1 }}
              @if (addDesignationsArray.length > 1) {
                <span> - <span class="fas fa-trash-alt" (click)="removeDesignationRow(i)" ngbTooltip="Remove"></span></span>
              }
            </div>
            <div class="row">
              <mat-form-field appearance="fill" class="invite-form-field">
                <mat-label for="emailAddress" class="clrsgn-label">
                  Email Address
                </mat-label>
                <input matInput
                  maxlength="128"
                  type="text"
                  formControlName="emailAddress"
                  id="emailAddress">
                  <app-form-error [group]="addDesignationForm"
                  [controlName]="'designationAccounts.' + i + '.emailAddress'"></app-form-error>
                </mat-form-field>
              </div>
              <div class="row align-center">
                <mat-form-field appearance="fill" class="invite-form-field">
                  <mat-label for="designationCode" class="clrsgn-label">
                    Designation
                  </mat-label>
                  <mat-select formControlName="designationCode"
                    id="designationCode"
                    data-cy="designationsDropdownList">
                    @for (type of designations; track type.key) {
                      <mat-option
                        [value]="type.key">
                        {{ type.value }}
                      </mat-option>
                    }
                  </mat-select>
                  <app-form-error [group]="addDesignationForm"
                  [controlName]="'designationAccounts.' + i + '.designationCode'"></app-form-error>
                </mat-form-field>
              </div>
            </div>
          }
        </div>
        <button type="button" class="btn-secondary" (click)="addDesignationRow()">+ Add Another</button>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn-secondary" (click)="close()">Cancel</button>
      <button type="button" class="btn-primary" (click)="addDesignations()">Add Designations</button>
    </div>
  </ng-container>
